<template>
  <div>
    <v-container align="center" style="padding-left: 5%; padding-right: 5%;">
      <v-row align="center" justify="center">
        <v-flex>
          <v-img src="@/assets/sponsers/R4DM24_sponsorilogot/R4DM24_valostore_logo.png" contain max-width="200px" style="cursor: pointer" @click.stop="openNewTab('https://www.valostore.fi/')"></v-img>
        </v-flex>
        <v-flex>
          <v-img src="@/assets/sponsers/R4DM24_sponsorilogot/R4DM24_ecoaims_logo.png" contain max-width="200px" style="cursor: pointer" @click.stop="openNewTab('https://www.ecoaims.com')"></v-img>
        </v-flex>
        <v-flex>
          <v-img src="@/assets/sponsers/QF_logo@2x.png" contain max-width="200px" style="cursor: pointer" @click.stop="openNewTab('https://q-factory.fi/')"></v-img>
        </v-flex>
      </v-row>
    </v-container>
    <v-container align="center" style="padding-top: 50px;">
      <v-row align="center" justify="center">
        <v-flex>
          <div>
            <a href="http://palkinto-pajarinen.fi/" style="text-decoration: none; font-size: small;">Palkinto-Pajarinen</a>
          </div>
        </v-flex>
        <v-flex>
          <div>
            <a href="https://vuoksenhuoltopalvelu.fi/" style="text-decoration: none; font-size: small;">Vuoksen Huolto- ja Asennuspalvelu</a>
          </div>
        </v-flex>
        <v-flex>
          <div>
            <a href="https://www.joensuunsar.fi/" style="text-decoration: none; font-size: small;">Aseliike Joensuun SAR</a>
          </div>
        </v-flex>
        <v-flex>
          <div>
            <a href="https://almpartners.fi" style="text-decoration: none; font-size: small;">ALM Partners</a>
          </div>
        </v-flex>
        <v-flex>
          <div>
            <a href="https://www.thinkit.fi/" style="text-decoration: none; font-size: small;">Tukikomppania</a>
          </div>
        </v-flex>
      </v-row>
    </v-container>


    
  </div>
</template>

<script>
export default {
  name: "Sponsers",
  methods: {
    openNewTab(link) {
      window.open(link, '_blank').focus();
    }
  },
}
</script>

<style scoped>
  .centerer {
    text-align: center;
    padding-top: 25px;
  }
  .centerer a {
    text-decoration: none;
  }
</style>